import styled from 'styled-components';

export const DataStyled = styled.div`
  padding-top: 75px;
  margin-bottom: 320px;
  .container {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    position: relative;
    @media (min-width: 768px) {
      flex-direction: row;
      align-items: center;
      margin-top: 50px;
    }
  }
  @media (min-width: 992px) {
    margin-bottom: 210px;
  }
`;
export const LeftColumn = styled.div`
  img {
    object-fix: cover;
    max-width: 96px;
  }
  &.hide {
    visibility: hidden;
  }
  @media (min-width: 768px) {
    visibility: visible;
    max-width: 354px;
  }
`;
export const Title = styled.div`
  color: var(--black);
  font-family: Rubik;
  font-size: 48px;
  font-weight: bold;
  letter-spacing: -1px;
  line-height: 56px;
  @media (min-width: 992px) {
    font-size: 64px;
    line-height: 72px;
  }
`;

export const Card = styled.div`
  box-sizing: border-box;
  width: 355px;
  min-height: 120px;
  border-radius: 20px 0 0 20px;
  background-color: var(--white);
  box-shadow: 0 8px 20px 0 rgba(29, 66, 138, 0.15);
  font-family: Rubik;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  padding: 24px 44px 24px 24px;

  strong {
    font-weight: bold;
    color: var(--blue);
  }
  &:not(:last-of-type) {
    margin-bottom: 24px;
  }
  &.hide {
    visibility: hidden;
  }
  @media (min-width: 992px) {
    border-radius: 20px;
    min-height: 120px;
    width: 648px;
    padding: 25px 40px 35px;
    visibility: visible;
    &:nth-of-type(1) {
      width: 648px;
    }
    &:nth-of-type(2) {
      margin-left: 75px;
      width: 648px;
    }
    &:nth-of-type(3) {
      width: 552px;
    }
  }
`;

export const CardsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  position: relative;
  margin-left: -184%;
  height: 664px;
  @media (min-width: 768px) {
    height: 552px;
    margin-left: 10%;
  }
  @media (min-width: 992px) {
    margin-left: -20%;
  }
  @media (min-width: 992px) {
    margin-left: -12%;
  }
`;

export const RightColumn = styled.div`
  position: relative;
  box-sizing: border-box;
  height: 664px;
  width: 128px;
  border-radius: 40px 0 0 40px;
  background-color: #d0dde7;
  left: 70%;
  img {
    display: none;
    position: absolute;
    width: 100%;
    height: 552px;
    max-width: 708px;
    object-fit: cover;
    &.hide {
      visibility: hidden;
    }
    @media (min-width: 768px) {
      visibility: visible;
      display: inline;
    }
  }
  @media (min-width: 768px) {
    background-color: transparent;
    clip-path: none;
    margin: 0;
    border-radius: none;
    height: 552px;
    width: 100vw;
    // width: 708px;
    transform: translateX(25%);
    left: 50%;
    right: 50%;
    margin-left: -80%;
    margin-right: -50vw;
  }
  @media (min-width: 992px) {
    margin-left: -62%;
  }
  @media (min-width: 1024px) {
    margin-left: -60%;
  }
  @media (min-width: 1440px) {
    margin-left: -62%;
  }
  @media (min-width: 1920px) {
    margin-left: -50%;
  }
  @media (min-width: 2520px) {
    margin-left: -36%;
  }
`;
